module.exports = __webpack_public_path__ + "static/media/stock-issue.d37e464c.svg";